import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { atlasAuthMe } from '../../api'

export const RequireAtlasAuth = () => {
  const location = useLocation()
  const [status, setStatus] = useState<'pending' | 'authenticated' | 'unauthenticated'>('pending')

  useEffect(() => {
    let cancelled = false

    atlasAuthMe().then(session => {
      if (!cancelled) {
        setStatus(session.authenticated ? 'authenticated' : 'unauthenticated')
      }
    })

    return () => {
      cancelled = true
    }
  }, [])

  if (status === 'pending') {
    return null
  }

  if (status === 'unauthenticated') {
    const returnUrl = encodeURIComponent(`${location.pathname}${location.search}`)
    return <Navigate to={`/atlas/login?returnUrl=${returnUrl}`} replace />
  }

  return <Outlet />
}
